<div class="head">

  <div class="head-top">
    <ng-container *appHasRole="['user']">
      <div class="logo">
        <!--<img src="logo_cristian.jpg" />-->
        <img src="img/logo-m4n-dropped.png" />
      </div>
    </ng-container>


    <nav class="nav-desktop" *appHasRole="['user']">

      @for (item of desktopMenuItems(); track item.title) {
      <a [routerLink]="item.link"
        routerLinkActive
        [routerLinkActiveOptions]="{ exact: true }"
        #rla="routerLinkActive"
        [class.active]="rla.isActive"
        class="nav-pill">
        <i [ngClass]="item.pill"></i>{{ item.title }}
        <span *ngIf="item.isNew" class="badge-new">NEW</span>
      </a>
      }

      <button
        type="button"
        class="nav-pill"
        (click)="openIssueDialog()"
        aria-label="Support"
        title="Support">
        <i class="fa-solid fa-bug"></i>Support
      </button>

      @if (desktopLogoutItem(); as logoutItem) {
      <a [routerLink]="logoutItem.link"
        routerLinkActive
        [routerLinkActiveOptions]="{ exact: true }"
        #rlaLogout="routerLinkActive"
        [class.active]="rlaLogout.isActive"
        class="nav-pill"
        [attr.aria-label]="logoutItem.title || 'Logout'"
        title="Logout">
        <i [ngClass]="logoutItem.pill"></i>{{ logoutItem.title }}
      </a>
      }

    </nav>

    <div class="mobile-actions" *appHasRole="['user']">
      <button class="burger"
              (click)="toggleMenu()"
              [attr.aria-label]="menuOpen() ? 'Close menu' : 'Open menu'">

        <i class="fa-solid"
           [ngClass]="menuOpen() ? 'fa-xmark' : 'fa-bars'">
        </i>

      </button>
    </div>

  </div>

  <nav class="nav-mobile"
       *appHasRole="['user']"
       [class.open]="menuOpen()">

    <div class="nav-mobile-header">

      <img src="logo-matchedtrading-web-optimized.png" />
      <!--<picture>
        <source srcset="logo-matchedtrading-160x50.png" media="(max-width: 768px)">
        <img src="logo-matchedtrading-220x70.png"
             width="220"
             height="70"
             alt="Matched Trading">
      </picture>-->
      <!--<button class="close"
          (click)="toggleMenu()">
    <i class="fa-solid fa-xmark"></i>
  </button>-->

    </div>

    @for (item of mobileMenuItems(); track item.link + item.title) {

    <a [routerLink]="item.link"
       (click)="toggleMenu()"
       class="nav-mobile-item">

      <i [ngClass]="item.pill"></i>
      {{ item.title }}

    </a>

    }

    <button
       type="button"
       (click)="toggleMenu(); openIssueDialog()"
       class="nav-mobile-item"
       style="width:100%; text-align:left;">

      <i class="fa-solid fa-bug"></i>
      Support

    </button>

    @if (mobileLogoutItem(); as logoutItem) {
    <a [routerLink]="logoutItem.link"
       (click)="toggleMenu()"
       class="nav-mobile-item">

      <i [ngClass]="logoutItem.pill"></i>
      {{ logoutItem.title }}

    </a>
    }

  </nav>
  <div class="nav-overlay"
       *ngIf="menuOpen()"
       (click)="toggleMenu()">
  </div>

</div>

<dialog
  #issueDialog
  class="nt-modal-shell"
  (cancel)="onIssueDialogCancel($event)"
  (click)="onIssueDialogBackdrop($event)">
  <div
    style="width:min(100%, 680px); margin:0 auto; padding:1.6rem; border:1px solid rgba(59,130,246,0.28); border-radius:1.25rem; background:linear-gradient(180deg, rgba(15,23,42,0.98), rgba(2,6,23,0.98)); box-shadow:0 24px 70px rgba(2,6,23,0.58);"
    (click)="$event.stopPropagation()">
    <div style="display:flex; align-items:flex-start; justify-content:space-between; gap:1rem; margin-bottom:1rem;">
      <div style="display:grid; gap:0.35rem;">
        <span class="text1-label">Support</span>
        <h2 style="margin:0; color:#f8fbff; font-size:1.6rem; line-height:1.08; font-weight:900;">New malfunction report</h2>
        <p style="margin:0; color:#9fb3c8; line-height:1.45;">
          Send a report with the current page context so the admin team can review it quickly.
        </p>
      </div>

      <button
        class="btn"
        type="button"
        (click)="closeIssueDialog()"
        aria-label="Close"
        style="min-width:42px; height:42px; padding:0; border-radius:0.9rem; border:1px solid rgba(148,163,184,0.24); background:rgba(15,23,42,0.72); color:#dbe7f5;">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div style="display:grid; grid-template-columns:repeat(2, minmax(0, 1fr)); gap:1rem; margin-bottom:1rem;">
      <div style="display:grid; gap:0.35rem;">
        <span class="text1-label">Current page</span>
        <div class="text1-value">{{ router.url }}</div>
      </div>

      <label style="display:grid; gap:0.35rem;">
        <span class="text1-label">Priority</span>
        <select [ngModel]="reportPriority()" (ngModelChange)="reportPriority.set($event)">
          <option value="low">Low</option>
          <option value="normal">Normal</option>
          <option value="high">High</option>
          <option value="critical">Critical</option>
        </select>
      </label>
    </div>

    <div style="display:grid; gap:0.6rem; margin-bottom:1rem;">
      <div style="display:flex; align-items:center; justify-content:space-between; gap:0.75rem; flex-wrap:wrap;">
        <span class="text1-label">Image attachment</span>
        <div style="display:flex; align-items:center; gap:0.5rem; flex-wrap:wrap;">
          <input
            #issueImageInput
            type="file"
            accept="image/*"
            hidden
            (change)="onIssueImageSelected($event)" />
          <button class="btn gc-button gc-button--secondary" type="button" [disabled]="reportSaving()" (click)="openIssueImagePicker()">
            Attach image
          </button>
          @if (screenshotPreviewUrl()) {
            <button class="btn gc-button gc-button--secondary" type="button" [disabled]="reportSaving()" (click)="clearIssueImage()">
              Remove
            </button>
          }
        </div>
      </div>

      @if (screenshotPreviewUrl()) {
        @if (screenshotFileName()) {
          <div style="color:#9fb3c8; font-size:0.9rem; line-height:1.4;">
            Attached: <strong style="color:#dbeafe;">{{ screenshotFileName() }}</strong>
          </div>
        }
        <img
          [src]="screenshotPreviewUrl()!"
          alt="Attached image preview"
          style="display:block; width:100%; max-height:240px; object-fit:cover; border-radius:0.9rem; border:1px solid rgba(59,130,246,0.22);" />
      } @else {
        <div style="padding:0.9rem 1rem; border:1px dashed rgba(148,163,184,0.28); border-radius:0.9rem; color:#9fb3c8;">
          No image attached yet.
        </div>
      }

      @if (screenshotError()) {
        <div class="nt-dialog-feedback nt-dialog-feedback--info" role="status" aria-live="polite">
          {{ screenshotError() }}
        </div>
      } @else {
        <div style="color:#9fb3c8; font-size:0.92rem; line-height:1.45;">
          Attach an image from your device to help the admin team review the issue faster.
        </div>
      }
    </div>

    <label style="display:grid; gap:0.35rem; margin-bottom:1rem;">
      <span class="text1-label">Title</span>
      <input
        type="text"
        placeholder="Short summary of the malfunction"
        [ngModel]="reportTitle()"
        (ngModelChange)="reportTitle.set($event)" />
    </label>

    <label style="display:grid; gap:0.35rem;">
      <span class="text1-label">Description</span>
      <textarea
        rows="7"
        placeholder="Describe what happened, what you expected, and how to reproduce it."
        [ngModel]="reportDescription()"
        (ngModelChange)="reportDescription.set($event)"
        style="resize:vertical;"></textarea>
    </label>

    @if (reportError()) {
      <div class="nt-dialog-feedback nt-dialog-feedback--error" role="alert" aria-live="assertive" style="margin-top:1rem;">
        {{ reportError() }}
      </div>
    }

    <div style="display:flex; justify-content:flex-end; gap:0.75rem; margin-top:1.2rem;">
      <button class="btn gc-button gc-button--secondary" type="button" [disabled]="reportSaving()" (click)="closeIssueDialog()">
        Cancel
      </button>
      <button class="btn gc-button gc-button--primary" type="button" [disabled]="reportSaving()" (click)="submitIssueReport()">
        @if (reportSaving()) {
          Sending...
        } @else {
          Send report
        }
      </button>
    </div>
  </div>
</dialog>
